import { ANALYTICS } from 'utils/analytics/consts'
import { Analytics } from 'utils/analytics/types'

export const mutateAnalyticsData = (params: Analytics) => {
  Object.assign(ANALYTICS, params)
}
